import React from 'react';
import { LayoutGridIcon, CalendarRangeIcon, FilmIcon, CalendarDaysIcon, BarChart3Icon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { LOGO_URL } from '../../data/links';
const icons = [LayoutGridIcon, CalendarRangeIcon, FilmIcon, CalendarDaysIcon, BarChart3Icon];
export function AppSidebar({
  active
}: {
  active: number;
}) {
  const {
    t
  } = useLanguage();
  return <aside className="hidden w-48 shrink-0 flex-col gap-0.5 border-r border-white/[0.06] p-3 md:flex" aria-hidden="true" data-id="element-48" data-mp="1vesksc0wjo98">
      <div className="mb-3 flex items-center gap-2 px-2 py-2" data-id="element-49" data-mp="1menn4tlig489">
        <img src={LOGO_URL} alt="" className="h-5 w-5 rounded-full" data-id="element-50" data-mp="1mct1te6bua3n" />
        <span className="text-[11px] font-semibold tracking-[0.18em] text-white/90" data-id="element-51" data-mp="1hehsd4jy21ly">
          PROFUMIND
        </span>
      </div>
      {t.ui.sidebar.map((label, i) => {
      const Icon = icons[i];
      return <div key={label} className={`flex items-center gap-2.5 rounded-md px-2 py-1.5 text-[12px] ${i === active ? 'bg-white/[0.08] text-white' : 'text-white/45'}`} data-id="element-52" data-mp="5yt66feil6m7" data-mpi={i}>
            <Icon className="h-3.5 w-3.5" data-id="element-53" data-mp="1g480ssa1fmoa" />
            {label}
          </div>;
    })}
    </aside>;
}